"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _errorMessage = _interopRequireDefault(require("./error-message"));
var _label = _interopRequireWildcard(require("./label"));
var _textfieldModule = _interopRequireDefault(require("./textfield.module.scss"));
var _field = require("./field");
var _fieldsize = _interopRequireWildcard(require("./fieldsize"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Textfield extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      value: this.props.value
    });
    (0, _defineProperty2.default)(this, "onChange", event => {
      this.setState({
        value: event.target.value
      });
      if (this.props.onChange) {
        this.props.onChange(event);
      }
    });
    (0, _defineProperty2.default)(this, "renderLabel", id => /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_label.default, {
      className: (0, _classnames.default)(this.props.classNames.label, {
        [_textfieldModule.default.errorLabel]: this.props.errorMessage
      }),
      for: id,
      tooltip: this.props.tooltip,
      size: this.props.size
    }, this.props.label), /*#__PURE__*/_react.default.createElement(_label.SubLabel, {
      className: (0, _classnames.default)(this.props.classNames.subLabel, {
        [_textfieldModule.default.errorLabel]: this.props.errorMessage
      }),
      size: this.props.size
    }, this.props.subLabel)));
    (0, _defineProperty2.default)(this, "renderField", id => /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: _textfieldModule.default.fieldIconContainer
    }, /*#__PURE__*/_react.default.createElement("input", {
      ref: this.props.innerRef,
      type: this.props.type,
      name: this.props.name,
      maxLength: this.props.maxLength,
      autoComplete: this.props.autoComplete,
      autoCorrect: this.props.autoCorrect,
      autoCapitalize: this.props.autoCapitalize,
      id: id,
      "data-test-id": this.props.dataTestId,
      value: this.state.value,
      className: (0, _classnames.default)({
        [_textfieldModule.default.field]: this.props.size === _fieldsize.default.DEFAULT
      }, {
        [_textfieldModule.default.fieldSmall]: this.props.size === _fieldsize.default.SMALL
      }, {
        [_textfieldModule.default.fieldInvalid]: this.props.errorMessage
      }, this.props.classNames.field),
      pattern: this.props.pattern,
      min: this.props.min,
      max: this.props.max,
      disabled: this.props.disabled,
      placeholder: this.props.placeholder,
      "aria-label": this.props.ariaLabel,
      step: this.props.step,
      inputMode: this.props.inputMode,
      onChange: this.onChange,
      onBlur: this.props.onBlur,
      onFocus: this.props.onFocus
    })), this.props.showCharacterCount && /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_textfieldModule.default.characterCountWrapper, this.props.classNames.characterCountWrapper)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_textfieldModule.default.characterCount, {
        [_textfieldModule.default.error]: this.exceedsMaxLength()
      })
    }, this.getCharacterCount())), this.props.errorMessage && /*#__PURE__*/_react.default.createElement(_errorMessage.default, {
      size: this.props.size,
      message: this.props.errorMessage,
      className: this.props.classNames.errorMessage
    })));
  }
  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState((_state, props) => ({
        value: props.value
      }));
    }
  }
  getSuggestedLength() {
    return this.props.suggestedLength || this.props.maxLength;
  }
  getCharacterCount() {
    return this.getSuggestedLength() - this.state.value.length;
  }
  exceedsMaxLength() {
    return this.state.value.length > this.getSuggestedLength();
  }
  render() {
    const id = this.props.id || (0, _field.makeIdString)();
    const wrapperOpts = {
      isHorizontal: this.props.isHorizontal,
      classNames: this.props.classNames
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_textfieldModule.default.Textfield, this.props.classNames.wrapper, {
        [_textfieldModule.default.TextfieldHorizontal]: this.props.isHorizontal
      })
    }, (0, _field.wrapIfHorizontal)({
      ...wrapperOpts,
      type: 'Label'
    }, this.renderLabel(id)), (0, _field.wrapIfHorizontal)({
      ...wrapperOpts,
      type: 'Field'
    }, this.renderField(id)));
  }
}
exports.default = Textfield;
Textfield.propTypes = {
  ..._field.textfieldPropTypes
};
Textfield.defaultProps = {
  type: 'text',
  value: '',
  classNames: {},
  inputMode: 'text',
  ..._fieldsize.fieldSizeDefaultProps
};